import { axiosConfigNew as axios } from "../../../utils/axios";

export const getPsychologistScheduleApi = (params: any) => axios.get(`/psychologist/work-schedule`, {
  params: params
});
export const getPsychologistScheduleByIDApi = (id: any) => axios.get(`/psychologist/work-schedule/${id}`);

export const postPsychologistScheduleApi = (body: any) => {
  if (body?.id) {
    return axios.put(`/psychologist/work-schedule/${body?.id}`, body);
  }
  return axios.post(`/psychologist/work-schedule`, body);
}

export const deletePsychologistScheduleApi = (id: any) => axios.delete(`/psychologist/work-schedule/${id}`);


export const getPsychologistWorkApi = (params: any) => axios.get(`/psychologist/work`, {
  params: params
});

export const getPsychologistWorkByOneApi = (id: any) => axios.get(`/psychologist/work/${id}`);

export const postPsychologistWorkApi = (body: any) => {
  if (body?.id) {
    return axios.put(`/psychologist/work/${body?.id}`, body);
  }
  return axios.post(`/psychologist/work`, body);
}

export const deletePsychologistWorkApi = (id: any) => axios.delete(`/psychologist/work/${id}`);

export const getPsychologistWorkFilterApi = (params: any) => axios.get(`/psychologist/work-filter`, {
  params: params
});

export const getPsychologistGroupApi = () => axios.get(`/psychologist/group`);

export const getPsychologistGroupByIDApi = (id: any) => axios.get(`/psychologist/group/${id}`);

export const getPsychologistTeachersApi = (id: any) => axios.get(`/psychologist/teacher`);
